import OccupancyCheckBox from "./OccupancyCheckBox";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./Reservation.scss";

const PricesBox = () => (
  <div className="prices-box">
    <div className="price-row">
      <div className="price-label">iki 5 parų</div>
      <div className="price-value">3.50€/para</div>
    </div>
    <div className="price-row">
      <div className="price-label">6–13 parų</div>
      <div className="price-value">3.30€/para</div>
    </div>
    <div className="price-row">
      <div className="price-label">14 parų ir ilgiau</div>
      <div className="price-value">3.10€/para</div>
    </div>
  </div>
);

const CheckOccupancy = () => {
  return (
    <section id="reservation">
      <div className="reservation-container">
        <div className="occupancy-check-container">
          <h1 className="header">
            Pigus <span className="header-highlight">parkavimas</span> prie
            Kauno oro uosto
          </h1>

          <p className="description">
            Rezervuokite automobilių stovėjimo vietą vos per kelias minutes
          </p>

          <div className="prices-container prices-mobile">
            <PricesBox />
          </div>

          <OccupancyCheckBox />
        </div>

        <div className="prices-container prices-desktop">
          <div className="prices-label">KAINOS</div>
          <PricesBox />
        </div>
      </div>
    </section>
  );
};

export default CheckOccupancy;
